import _get from 'lodash/get';
import { FilterGroupingEnum, TaskFilterInputObject } from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import { FieldNames } from '../enums';

interface OptionItem {
  value: string;
  label: string;
  [key: string]: unknown;
}

export function createAdditionalFilters(
  filterValues: Values,
): TaskFilterInputObject[] {
  const filters: TaskFilterInputObject[] = [];

  // Process Sites filter
  const sites = _get(filterValues, FieldNames.Sites, []) as OptionItem[];
  if (sites && sites.length > 0) {
    const siteIds = sites.map((site) => site.value);
    filters.push({
      siteId: {
        grouping: FilterGroupingEnum.And,
        predicate: { in: siteIds },
        filterGroup: 'additionalFilters',
      },
    });
  }

  // Process Equipment filter
  const equipment = _get(
    filterValues,
    FieldNames.Equipment,
    [],
  ) as OptionItem[];
  if (equipment && equipment.length > 0) {
    const assetIds = equipment.map((asset) => asset.value);
    filters.push({
      assetId: {
        grouping: FilterGroupingEnum.And,
        predicate: { in: assetIds },
        filterGroup: 'additionalFilters',
      },
    });
  }

  // Process Form Categories filter
  const formCategories = _get(
    filterValues,
    FieldNames.FormCategories,
    [],
  ) as OptionItem[];
  if (formCategories && formCategories.length > 0) {
    const categoryIds = formCategories.map((category) => category.value);
    filters.push({
      formCategoryId: {
        grouping: FilterGroupingEnum.And,
        predicate: { in: categoryIds },
        filterGroup: 'additionalFilters',
      },
    });
  }

  return filters;
}
